import request from '@/utils/request'

// 列表
export function apiInvCallRequestLinesOutboundList (query) {
  return request({
    url: '/inv/invCallRequestLines/outboundList',
    method: 'get',
    params: query
  })
}

// 保存
export function apiInvCallRequestLinesOutbound (data) {
  return request({
    url: '/inv/invCallRequestLines/outbound',
    method: 'put',
    data: data
  })
}

// 导出列表
export function apiInvCallRequestLinesOutboundListExportNewExport (data) {
  return request({
    url: '/inv/invCallRequestLines/v2/outboundListExport',
    method: 'post',
    data: data
  })
}
